"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var EvaluationUtils = /** @class */ (function () {
    function EvaluationUtils() {
    }
    EvaluationUtils.getUnitID = function (user, idType) {
        var _a, _b, _c;
        if (typeof idType === 'string' && idType.toLowerCase() !== 'userid') {
            return ((_b = (_a = user === null || user === void 0 ? void 0 : user.customIDs) === null || _a === void 0 ? void 0 : _a[idType]) !== null && _b !== void 0 ? _b : (_c = user === null || user === void 0 ? void 0 : user.customIDs) === null || _c === void 0 ? void 0 : _c[idType.toLowerCase()]);
        }
        return user === null || user === void 0 ? void 0 : user.userID;
    };
    return EvaluationUtils;
}());
exports.default = EvaluationUtils;
